import { REQUEST, RECEIVE, SELECT } from '../types/kreise'
import { getCurrentTs } from '../utils/Utils'


let preSelectedKreis = null;
if (window.bbvTermine && window.bbvTermine.kvnr) {
    preSelectedKreis = window.bbvTermine.kvnr;
}

const initialState = {
    list: {},
    selected: preSelectedKreis,
    isFetching: false,
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case RECEIVE:
            let kreise = {};
            action.data.forEach(kreis=>{
               if (!kreise[kreis.bezirksnummer]) {
                   kreise[kreis.bezirksnummer] = [];
               }
               kreise[kreis.bezirksnummer].push(kreis);
            });
            return Object.assign({}, state, {
                list: kreise,
                timestamp: getCurrentTs(),
                isFetching: false
            })
        case REQUEST:
            return Object.assign({}, state, {
                isFetching: true
            })
        case SELECT:
            return Object.assign({}, state, {
                selected: action.kvnr
            })
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/kreise.js